module.exports = __webpack_public_path__ + "3c3d0242794b4682460a3f7c7a2126ee.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-design-icons/iconfont/MaterialIcons-Regular.woff
 ** module id = 18
 ** module chunks = 0
 **/